import { relatedTopics } from "@/mocks/home";

export default function Related() {
  return (
    <section id="related" className="bg-background-100 border-t border-background-200">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div className="max-w-2xl">
            <span className="text-xs md:text-sm font-medium tracking-wide text-accent-700">
              延伸阅读
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-foreground-950 leading-snug">
              与之相关的浏览方向
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
              这几个方向常和“完整版”一起被检索，如果你已经了解版本概念，可以继续往下看看更具体的说明。
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {relatedTopics.map((topic) => (
            <article
              key={topic.id}
              className="group flex flex-col overflow-hidden rounded-lg bg-background-50 border border-background-200 transition-colors hover:border-accent-300"
            >
              <div className="w-full aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={topic.img}
                  alt={`${topic.title}相关的暖色调示意图`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-col flex-1 p-5">
                <span className="self-start px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium">
                  {topic.tag}
                </span>
                <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950">
                  {topic.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{topic.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}